export const getMateriaById = (materias, materiaId) => {
  const materia = Array.isArray(materias)
      && materias.find(materia => materia.id === materiaId);
  return materia;
};

export const setMateriaToEdit = (materias, materia) => {
    const materiaFound = Array.isArray(materias) && materia;
  const materiaToEdit = {
    ...materiaFound,
    nombre: materia.nombre,
    id_academia: materia.id_academia,
    nombreAcademia: materia.nombreAcademia,
    isPublica: materia.isPublica,
  }
  return materiaToEdit;
};